var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.9999,
    r: 12,
    transform: "rotate(-90 12 11.9999)",
    fill: "#F24B27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80062 17.9457C8.59037 18.2075 8.26426 18.3507 7.93373 18.2915C7.43222 18.2017 6.70569 18.015 6.34611 17.654C5.98543 17.2919 5.80171 16.5612 5.71425 16.0592C5.65706 15.731 5.79904 15.4078 6.05826 15.1985C7.01641 14.4248 9.41716 12.4554 10.9394 10.9394C12.4625 9.42245 14.4491 7.02174 15.2285 6.06512C15.4389 5.80692 15.7625 5.66644 16.0903 5.72493C16.592 5.81442 17.322 6.0011 17.6828 6.3633C18.0424 6.72436 18.2261 7.45167 18.3138 7.95354C18.3717 8.28429 18.2272 8.60979 17.9645 8.81897C16.997 9.58961 14.5816 11.546 13.0607 13.0607C11.54 14.5752 9.57492 16.9815 8.80062 17.9457Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05685 8.79826C5.79461 8.58853 5.65072 8.26272 5.70925 7.93207C5.79805 7.43038 5.98322 6.70347 6.34353 6.34315C6.70495 5.98174 7.4352 5.79654 7.93704 5.70806C8.26516 5.6502 8.58864 5.79152 8.79849 6.05032C9.57413 7.00689 11.5483 9.40364 13.0675 10.9228C14.5875 12.4428 16.9922 14.4245 17.9504 15.202C18.2091 15.4118 18.3502 15.7351 18.2924 16.0631C18.2039 16.565 18.0187 17.2954 17.6572 17.6569C17.2969 18.0172 16.57 18.2024 16.0683 18.2912C15.7377 18.3497 15.4119 18.2058 15.2021 17.9436C14.4295 16.9776 12.4682 14.5662 10.9505 13.0484C9.43285 11.5308 7.0226 9.5706 6.05685 8.79826Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e458d823a6fb5f16ef050d810ded9ff2.svg";
export { ForwardRef as ReactComponent };